import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { fanDrillBrand, companyInfo } from '../data/mock';

const BrandsSection = () => {
  return (
    <section id="brands" className="py-24 md:py-32 bg-slate-950 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-slate-900/50 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-cyan-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Our Brand
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Fantasy Sports Platform
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Platforms built on Mind Flex Games' skill-based and compliance-first foundation.
          </p>
        </div>

        {/* FanDrill Card */}
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-3xl overflow-hidden">
            {/* Decorative gradient */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 via-blue-500 to-orange-500" />
            
            <div className="p-8 md:p-12">
              <div className="flex flex-col lg:flex-row items-center gap-10">
                {/* Logo Section */}
                <div className="flex-shrink-0 w-full lg:w-auto">
                  <a 
                    href="https://fandrill.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block bg-white rounded-2xl p-4 md:p-6 shadow-xl hover:shadow-2xl transition-shadow duration-300 max-w-xs mx-auto lg:mx-0"
                  >
                    <img
                      src={companyInfo.logos.fanDrill}
                      alt="FanDrill - Daily Fantasy Sports"
                      className="h-12 md:h-16 w-auto object-contain"
                    />
                  </a>
                </div>

                {/* Content Section */}
                <div className="flex-1 text-center lg:text-left">
                  <div className="inline-flex items-center space-x-2 text-sm text-orange-400 font-medium mb-4">
                    <span className="w-2 h-2 rounded-full bg-orange-400" />
                    <span>{fanDrillBrand.tagline}</span>
                  </div>
                  
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                    {fanDrillBrand.name}
                  </h3>
                  
                  <p className="text-slate-400 mb-6 leading-relaxed">
                    {fanDrillBrand.description}
                  </p>

                  {/* Highlights */}
                  <ul className="space-y-3">
                    {fanDrillBrand.highlights.map((highlight, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <div className="flex-shrink-0 w-5 h-5 rounded-full bg-cyan-500/20 flex items-center justify-center mt-0.5">
                          <Check size={12} className="text-cyan-400" />
                        </div>
                        <span className="text-slate-300 text-sm">{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Footer note */}
            <div className="bg-slate-800/50 px-8 md:px-12 py-4 border-t border-slate-700/50">
              <p className="text-xs text-slate-500 text-center">
                FanDrill is a registered trademark of Mind Flex Games, LLC. Platform availability varies by jurisdiction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
